import React, { Component } from 'react';

import PropTypes from 'prop-types';

import LazyLoadedImage from 'common/LazyLoadedImage';
import nbspLastSpace from 'common/util/nbspLastSpace';
import Step1 from 'img/landing/features-step-1.webp';
import Step2 from 'img/landing/features-step-2.webp';
import Step3 from 'img/landing/features-step-3.webp';
import Step4 from 'img/landing/features-step-4.webp';

import Link from '../Link';

import 'css/components/www/_FeaturesChildPagePagination.scss';

const steps = {
  feedback: {
    url: 'collect-feedback',
    title: 'Feedback',
    image: Step1,
    desc: 'Use feedback data to understand feature impact and inform your product decisions.',
  },
  analyze: {
    url: 'analyze-feedback',
    title: 'Analyze',
    image: Step2,
    desc: 'Use feedback data to understand feature impact and inform your product decisions.',
  },
  roadmap: {
    url: 'product-roadmap',
    title: 'Roadmap',
    image: Step3,
    desc: 'Prioritize projects and communicate what your team is working on with a product roadmap.',
  },
  changelog: {
    url: 'product-changelog',
    title: 'Changelog',
    image: Step4,
    desc: 'Announce product updates to engage people with your newest features.',
  },
};

export default class FeaturesChildPagePagination extends Component {
  static propTypes = {
    currentPage: PropTypes.string,
  };

  renderSteps() {
    const { currentPage } = this.props;
    return (
      <div className="featuresChildPagePaginationItems">
        {Object.entries(steps).map(([step, { url, title, image, desc }], index) => {
          return (
            <Link
              className="paginationItem"
              activeClassName="disabled"
              disabled={currentPage === step}
              to={`/features/${url}`}
              key={index}>
              <div className="step">
                <LazyLoadedImage src={image} alt={`Step ${index + 1}`} />
                <div className="title">{title}</div>
                <div className="description">{nbspLastSpace(desc)}</div>
              </div>
            </Link>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="featuresChildPagePagination">
        <h2 className="heading">Explore the customer feedback&nbsp;cycle</h2>
        {this.renderSteps()}
      </div>
    );
  }
}
